type StoredLocalFile = {
  bytes: ArrayBuffer;
  name: string;
  type: string;
  lastModified: number;
};

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

export async function storeLocalFile(file: File): Promise<StoredLocalFile> {
  return {
    bytes: await file.arrayBuffer(),
    name: file.name,
    type: file.type,
    lastModified: file.lastModified,
  };
}

export function restoreLocalFile(value: unknown): File {
  if (typeof File === "undefined") {
    throw new Error("The browser File API is unavailable.");
  }
  if (value instanceof File) {
    return value;
  }
  if (
    !isRecord(value) ||
    !(value.bytes instanceof ArrayBuffer) ||
    typeof value.name !== "string" ||
    typeof value.type !== "string" ||
    typeof value.lastModified !== "number" ||
    !Number.isFinite(value.lastModified)
  ) {
    throw new Error("The saved image file is invalid.");
  }

  return new File([value.bytes], value.name, {
    type: value.type,
    lastModified: value.lastModified,
  });
}
